module.exports = __webpack_public_path__ + "img/008-profile.927bfd12.png";